import TrashIcon from '@/icons/TrashIcon.svg?react';
import { cn } from '@/utils/tailwind';

export function ManifestFunctionViewer(props: {
  name?: string;
  defaultName: string;
  onOpen: () => void;
  onRemove: () => void;
  readOnly?: boolean;
}) {
  return (
    <div
      className={cn(
        'inline-flex w-fit items-center gap-1 rounded-md border border-secondary bg-secondary px-1 py-1 pl-2',
        !props.name && 'border-dashed bg-transparent'
      )}
    >
      <button
        type="button"
        className="flex items-center justify-between"
        onClick={props.onOpen}
        data-testid="manifest-function-viewer"
      >
        <span className="text-sm leading-none">
          {props.name || props.defaultName}
        </span>
      </button>
      {!props.readOnly && (
        <button
          type="button"
          onClick={props.onRemove}
          className="rounded p-1 hover:bg-secondary-hover active:bg-secondary"
        >
          <TrashIcon />
        </button>
      )}
    </div>
  );
}
